/* eslint-disable no-underscore-dangle */
class ItemCaching implements MerchantosItemCaching {
  _items: MerchantosItemCaching['_items'];

  constructor() {
    this._items = {};
  }

  /**
   * Saves an item and updates the cache
   *
   * @param id The id of the item to be saved
   * @param item The item to save with its attributes updated
   * @returns Promise
   */
  save: MerchantosItemCaching['save'] = (id, item) => {
    const deferred = $.Deferred();
    let url = `/API/Account/${window.merchantos.session.getSystemCustomerID()}`;
    url += `/Item/${id}.json`;

    window.lsCloud
      .startServerJob({
        type: 'PUT',
        // @ts-expect-error ts-migrate(2322) FIXME: Type 'unknown' is not assignable to type '{ [key: ... Remove this comment to see the full error message
        obj: item,
        url,
      })
      .done((response) => {
        let images = {};
        // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
        if (this._items[id]) {
          // If the item hasn't been loaded before, it doesn't have any
          // images yet;
          // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
          images = this._items[id].Images;
        }

        // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
        this._items[id] = response.Item;
        // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
        this._items[id].Images = images;
        // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
        deferred.resolve(this._items[id]);
      })
      // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
      .fail(() => deferred.reject(this._items[id]));

    return deferred.promise();
  };

  /**
   * Retrieves an item, either from a local cache or the API. If a request for
   * the same item is already in flight, will return the promise for that
   * request; otherwise, will initiate new API call
   *
   * @param id The id of the item to retrieve
   * @param forceReload If true, reload from API
   * @returns Promise
   */
  load: MerchantosItemCaching['load'] = (id, forceReload) => {
    const deferred = $.Deferred();

    // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
    if (this._items[id] && !forceReload) {
      // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
      if (this._items[id].itemID) {
        // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
        deferred.resolve(this._items[id]);
      } else {
        // If it doesn't have an ID, it's a promise from an earlier call
        // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
        return this._items[id];
      }
    } else {
      // No earlier calls, load from ajax
      const params = '?load_relations=["CustomFieldValues", "Images"]';
      let url = `/API/Account/${window.merchantos.session.getSystemCustomerID()}`;
      url += `/Item/${id}.json${params}`;

      // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
      this._items[id] = deferred.promise();

      window.lsCloud
        .getJSONFromAPI(url)
        .done((response) => {
          // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
          this._items[id] = response.Item;
          // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
          deferred.resolve(this._items[id]);
        })
        .fail(() => {
          // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
          this._items[id] = null;
          // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
          deferred.reject(this._items[id]);
        });
    }

    return deferred.promise();
  };

  /**
   * Used to update the images on a cached item. Image updates are done
   * without a call to the Item API, and therefore need to be updated manually
   *
   * @param itemID {Number} The id of the item to set the images on
   * @param images {Array} The images to set on the cached item
   */
  setImageCache: MerchantosItemCaching['setImageCache'] = (itemID, images) => {
    // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
    if (this._items[itemID]) {
      // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
      this._items[itemID].Images = { Image: images };
    }
  };

  // Add public functions to the merchantos object
  // global.

  flushCache: MerchantosItemCaching['flushCache'] = () => {
    this._items = {};
  };
}

window.merchantos.itemCaching = new ItemCaching();
